<template>
    <div
        :class="{ 'is-active': active }"
        class="dropdown"
        @click="$emit('click')"
    >
        <div class="dropdown-trigger">
            <button
                class="button"
                aria-haspopup="true"
                aria-controls="dropdown-menu"
            >
                <span class="lb-search-dropdown-filter-label" v-if="!filter"
                    >{{ $t('filter_project_type') }}
                </span>
                <span class="has-text-weight-bold pl-1" v-else>
                    {{ text }}
                </span>
                <span class="icon is-small">
                    <i class="fas fa-angle-down" aria-hidden="true"></i>
                </span>
            </button>
        </div>
        <div class="dropdown-menu" role="menu">
            <div class="dropdown-content">
                
                <a
                    v-if="allOption"
                    :key="'FILTER_OPTION_ALL'"
                    :class="{ 'is-active': 'FILTER_OPTION_ALL' == filter }"
                    class="dropdown-item is-size-6"
                    @click="$emit('update:filter', 'FILTER_OPTION_ALL')"
                    >{{ $t('Constants.FILTER_OPTION_ALL') }}</a
                >
                <a
                    v-for="option in options"
                    :key="option"
                    :class="{ 'is-active': option == filter }"
                    class="dropdown-item is-size-6"
                    @click="$emit('update:filter', option)"
                    >{{ textOption(option) }}</a
                >
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        filter: {
            type: String,
            required: true,
        },
        active: {
            type: Boolean,
            required: true,
            default: false,
        },
        options: {
            type: Array,
            required: true,
            default() {
                return [];
            },
        },
        allOption: {
            type: Boolean,
            default: true,
        },
        /*text: {
      type: String,
      default: this.$t("App.dropdown_filter")
    }*/
        /*text: {
            type: String,
            default: 'App.dropdown_filter',
        },*/
    },
    data() {
        return {};
    },
    computed: {
        text(){
            if (this.checkWhitespace(this.filter)) {
                return this.filter
            }else{
                return this.$t('Constants.'+this.filter);
            }
            // return this.filter
        }
    },
    methods: {
        textOption(option){
            if (this.checkWhitespace(option)) {
                return option
            }else{
                return this.$t('Constants.'+option);
            }
        },
        checkWhitespace(str) { 
            return /\s/.test(str); 
        } 
    },
};
</script>

<style></style>
